import { render, staticRenderFns } from "./comp_dpc-ListCardWithIcon.vue?vue&type=template&id=d04a6676&scoped=true&"
import script from "./comp_dpc-ListCardWithIcon.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-ListCardWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-ListCardWithIcon.vue?vue&type=style&index=0&id=d04a6676&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a6676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
